import format from '_shared_/plugins/format';
import { isValidValue } from '_shared_/utils/utils.js';
const getters = {
  getFundFacts: state => state.fundFacts
};

const mutations = {
  SET_FUND_FACTS(state, payload) {
    state.fundFacts = {
      InceptionDate: {
        label: 'Fund Inception',
        data: payload.InceptionDate || '--'
      },
      FundAssetsMillions: {
        label: 'Fund Assets (millions)',
        data: payload.FundAssetsMillions && format.formatHelpers.price(payload.FundAssetsMillions, 1) || '--',
        asOfDate: `As of ${payload.FundAssetsMillionsAsOfDate || '--'}`
      },
      TotalHoldingsCount: {
        label: 'Companies/Issuers',
        data: isValidValue(payload.TotalHoldingsCount) && `${payload.TotalHoldingsCount} +` || '--',
        asOfDate: `Holdings are as of ${payload.TotalHoldingsCountAsOfDate || '--'} (updated quarterly).`
      },
      DividendDistributionFrequency: {
        label: 'Regular Dividends Paid',
        data: payload.DividendDistributionFrequency && payload.DividendDistributionFrequency.split(',').join(', ') || '--'
      },
      CapitalGainDistributionFrequency: {
        label: 'Capital Gains Paid',
        data: payload.CapitalGainDistributionFrequency && payload.CapitalGainDistributionFrequency.split(',').join(', ') || '--'
      },
      PortfolioTurnover: {
        label: `Portfolio Turnover (${payload.PortfolioTurnoverYear || '--'})`,
        data: payload.PortfolioTurnover && format.formatHelpers.rawPercent(payload.PortfolioTurnover) || '--',
        asOfDate: ''
      },
      ProspectusDate: {
        label: 'Prospectus Date',
        data: payload.ProspectusDate || '--'
      },
      CUSIP: {
        label: 'CUSIP',
        data: payload.CUSIP || '--'
      },
      FundClassNumber: {
        label: 'Fund Number',
        data: payload.FundClassNumber || '--'
      },
      FiscalMonth: {
        label: 'Fiscal Year-End',
        data: payload.FiscalMonth || '--'
      }
    };
  }
};


const state = {
  fundFacts: null
};


export default {
  state,
  getters,
  mutations
};
